// extracted by mini-css-extract-plugin
export default {"adminDashboard":"AdminDashboard_adminDashboard__4HqAR"};